import { render, staticRenderFns } from "./SearchResultSuggestedFilters.vue?vue&type=template&id=ef61c2da&"
import script from "./SearchResultSuggestedFilters.vue?vue&type=script&lang=ts&"
export * from "./SearchResultSuggestedFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports